import { render, staticRenderFns } from "./combine-table.vue?vue&type=template&id=330dfa2b&scoped=true"
import script from "./combine-table.vue?vue&type=script&lang=js"
export * from "./combine-table.vue?vue&type=script&lang=js"
import style0 from "./combine-table.vue?vue&type=style&index=0&id=330dfa2b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330dfa2b",
  null
  
)

export default component.exports